module.exports = __webpack_public_path__ + "img/executor.675cb2d8.svg";